import {FormError, FormValues} from '@wix/form-viewer'
import {FormViewer, FormViewerContext, FormViewerHandle} from '@wix/form-viewer/widget'
import {Submissions, getFormId} from '@wix/wix-events-commons-statics'
import {useBi, useTranslation} from '@wix/yoshi-flow-editor'
import React, {useRef, useState} from 'react'
import {useAppProps, useAppSelector} from '../../hooks/runtime'
import {getDefaultFormValues, isMember} from '../../selectors/current-member-details'
import {getEvent} from '../../selectors/event'
import {FormViewerContextProps, WixFormProps} from './interfaces'
import s from './wix-form.scss'
import {classes} from './wix-form.st.css'

export const WixForm = ({onSubmit}: WixFormProps) => {
  const bi = useBi()
  const {i18n} = useTranslation()
  const appProps = useAppProps() as FormViewerContextProps

  const event = useAppSelector(getEvent)
  const member = useAppSelector(isMember)
  const defaultFormValues = useAppSelector(getDefaultFormValues)

  const formViewer = useRef<FormViewerHandle>(null)
  const [formValues, setFormValues] = useState<FormValues>(defaultFormValues)
  const [formErrors, setFormErrors] = useState<FormError[]>([])

  const formId = getFormId(event)
  const overrides = defaultFormValues.email && member ? {email: {disabled: true}} : {}

  const submitForm = async (_actionId, _formId, submissions: Submissions) => onSubmit(submissions)

  return (
    <FormViewerContext
      {...appProps}
      wfActions={{
        ...appProps.wfActions,
        submitForm,
      }}
    >
      <div className={`${classes.button} ${s.button}`}>
        <FormViewer
          i18n={i18n}
          bi={bi}
          ref={formViewer}
          values={formValues}
          errors={formErrors}
          formId={formId}
          overrides={overrides}
          onValidate={setFormErrors}
          onChange={setFormValues}
        />
      </div>
    </FormViewerContext>
  )
}
